const styles = ':host{--skapa-commercial-message-colour:rgb(var(--colour-commercial-message-new,202,80,8));background-color:var(--skapa-commercial-message-colour);color:rgb(var(--colour-text-and-icon-5,255,255,255));display:inline-block;font-size:var(--skapa-commercial-message-font-size,.75rem);font-weight:700;line-height:var(--skapa-commercial-message-line-height,1.1233);padding:.3333em .5em}:host([variant=nlp]){--skapa-commercial-message-colour:rgb(var(--colour-commercial-message-new-lower-price,204,0,8))}:host([variant=family]){--skapa-commercial-message-colour:rgb(var(--colour-commercial-message-ikea-family,0,124,193))}:host([subtle]){background-color:initial;color:var(--skapa-commercial-message-colour);line-height:var(--skapa-commercial-message-line-height,1.5);padding:0}';
import { SkapaElement } from "@ingka/skapa-webc-element";
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`<style>
      ${styles}
    </style>
    <slot></slot>`;
  return { main: template };
}
class CommercialMessage extends SkapaElement {
  constructor() {
    super();
    this.gatherProperties(["subtle", "variant"], this);
    const shadow = this.attachShadow({ mode: "open" });
    const template = this.getTemplates(generateTemplate);
    shadow.append(template.main.content.cloneNode(true));
  }
  get subtle() {
    return this.hasAttribute("subtle");
  }
  set subtle(toggle) {
    this.toggleAttribute("subtle", !!toggle);
  }
  get variant() {
    return this.getAttribute("variant") || "new";
  }
  set variant(value) {
    this.setAttribute("variant", value || "new");
  }
}
CommercialMessage.skapaTagName = "commercial-message";
CommercialMessage.skapaDependencies = [];
export {
  CommercialMessage
};
